// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import hui from 'h_ui/dist/h_ui.min.js'
import 'h_ui/dist/h_ui.min.css'
import './style/main.scss'// 开发theme时修改main.scss中引入的custom.scss
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueClipboard from 'vue-clipboard2'
import fetch,{xhr} from '@/api/httpFetch.js'

import {getMenuList} from './api/login.js'
import {rServiceValidate} from "@/api/bizApi/commonUtil";

Vue.prototype.LOCAL_CONFIG = window.LOCAL_CONFIG
Vue.prototype.$xhr = xhr

Vue.config.productionTip = false

Vue.use(hui)
Vue.use(ElementUI)
Vue.use(VueClipboard)
// const whiteList = ['/login','/loginIndex','/regist','/retrievepwd','/help','/clogin']

const whiteList = ['/regist','/retrievepwd','/clogin']


let routeLoaded = false

Vue.config.debug = true
// permissiom judge
function hasPermission(roles, permissionRoles) {
  if (roles.indexOf('admin') >= 0) return true; // admin权限 直接通过
  if (!permissionRoles) return true;
  return roles.some(role => permissionRoles.indexOf(role) >= 0)
}

function getMenu(){
  fetch.get('/resource/menu').then(response => {
          //console.log(response.data)
        })
}




function GetQueryString(name) {
      //获取URL参数
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(r[2]);
      return null;
};
let ticket=GetQueryString('ticket');
// getMenu()



let URL = window.location.href;


// store.subscribe((mutation, payload) => {
//   console.log(mutation)
// })


/* 页面刷新前进行权限校验 */
router.beforeEach((to, from, next) => {
console.log(to)
let userType=window.sessionStorage.getItem('userType')||'0';
/* 开启页面加载进度提示 */
  // debugger;
  // let roles = ['ROLE_ADMIN'];
  // if(!routeLoaded){
  //   store.dispatch('GenerateRoutes', { roles }).then(() => { // 生成可访问的路由表
  //     routeLoaded = true;
  //     router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
  //     next({...to}); // hack方法 确保addRoutes已完成
  //   })
  // }else{
  //   next();
  // }

/* 开启页面加载进度提示 */
  hui.hLoadingBar.start()
  //console.log('to.path'+to.query.sys)


  let sys=window.sessionStorage.getItem('sys')

  if (store.getters.token ) { //有token，证明已登录


    if (to.path === '/login'||to.path === '/loginIndex'||to.path === '/' || to.path==='clogin') {
      next({path: '/mainIndex'})
        return
    } else {
      if (!routeLoaded) {
        let roles = JSON.parse(sessionStorage['roles'])
        store.dispatch('GenerateRoutes', { roles }).then(() => { // 生成可访问的路由表
          routeLoaded = true;
          // console.log(store.getters.addRouters)
          router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
          // console.log(router)

          next({...to}); // hack方法 确保addRoutes已完成


        })
      } else {
       let arr=store.getters.addRouters
        if(sys){
          let arr2=[];
          arr.map(item=>{
              if(item.sys==sys){
                arr2.push(item)
              }
            });
          store.commit('UPDATA_ROUTE',arr2);
        }else{

          let arr3=[];
           arr.map(item=>{
              if(item.sys!=1){
                arr3.push(item)
              }
            });
           store.commit('UPDATA_ROUTE',arr3);
        };
        next()

      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      let userType=sessionStorage['userType'];
      // if(userType==1){
      //   next('./login')
      // }else{
      //   next('./loginIndex')
      // }
       next('./clogin')
      hui.hLoadingBar.finish()
    }
  }
})
router.afterEach(() => {
  hui.hLoadingBar.finish()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js